export const NO_CLASS_OPTION = 'personal'

export const HOOKS = {
  ImportStudentModes: 'classes-web:import-student-modes',
}

export const CLASS_STUDENTS_REFETCH_QUERIES = ['teacherClass', 'classStudentsAndTeachers']
